import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSettings = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.9999 8.21922C9.91111 8.22253 8.21984 9.91797 8.22095 12.0075C8.22205 14.0971 9.91511 15.7908 12.0039 15.7919C14.0928 15.793 15.7876 14.1011 15.7909 12.0115C15.786 9.91915 14.0916 8.22417 11.9999 8.21922ZM11.9999 14.7915C10.4618 14.7882 9.21764 13.5382 9.22096 11.9995C9.22427 10.4609 10.4738 9.21627 12.0119 9.21958C13.5501 9.22289 14.7943 10.4729 14.7909 12.0115C14.786 13.5495 13.5374 14.7932 11.9999 14.7915Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.127 9.65268L18.701 8.62332L20.147 6.02241L17.985 3.84164L15.379 5.30216L14.352 4.87701L13.53 2H10.47L9.648 4.871L8.664 5.27114L6.03 3.83364L3.836 6.02841L5.271 8.65933L4.881 9.59466L2 10.449V13.55L4.881 14.3923L5.272 15.3347L3.836 17.9676L6.03 20.1624L8.661 18.7269L9.603 19.118L10.445 22H13.554L14.397 19.116L15.383 18.7028L17.983 20.1494L20.149 17.9826L18.701 15.3817L19.127 14.3523L22 13.53V10.469L19.127 9.65268ZM21 12.7818L18.391 13.53L17.596 15.4517L18.912 17.8185L17.812 18.9189L15.445 17.6055L13.571 18.3907L12.871 20.7976L12.808 21.0127H11.199L11.136 20.7976L10.436 18.3907L8.609 17.6335L6.215 18.9399L5.079 17.8035L6.385 15.4087L5.617 13.5771L2.996 12.8098V11.2032L5.617 10.4239L6.374 8.60631L5.068 6.21147L6.204 5.07508L8.598 6.38153L10.472 5.61426L11.158 3.21342L11.22 2.99835H12.772L12.834 3.21342L13.52 5.61426L15.441 6.40954L17.807 5.08408L18.907 6.19147L17.591 8.5583L18.386 10.48L20.995 11.2282V12.7808L21 12.7818Z'
    />
  </svg>
);
export default SvgSettings;
